import React,{useState} from 'react'
import "./CSS/Navbar.css"
import logo from './images/logo.jpeg'
import { Link } from "react-router-dom";


function Navbar() {
    const [check, setCheck] = useState(false); 
  const handleChange = () => { 
    setCheck(!check);  
  }; 
  const handleChange1 = () => { 
    setCheck(!check);  
  }; 
  return (
    <body class="navbar-body">
    <header class="navbar-header">
        <div class="navbar-container">
            <nav class="navbar-nav">
                <a href="#" class="navbar-logo">
                    <img class="navbar-logo" src={logo} alt="Navbar-logo"/>
                </a>
                <input type="checkbox" name="navbar-menuBtn" id="navbar-menuBtn" checked={check}/>
                <label for="navbar-menuBtn" class="navbar-barIcon">
                    <i class="fa fa-bars" onClick={handleChange}></i>
                </label>
                <ul class="navbar-menu">
                    <li class="navbar-menu-li"><Link to="/" class="navbar-menu-links" onClick={handleChange1}>home</Link></li>
                    <li class="navbar-menu-li"><Link to="/blogs" class="navbar-menu-links" onClick={handleChange1}>blogs</Link></li>
                    <li class="navbar-menu-li"><Link to="/aboutus" class="navbar-menu-links" onClick={handleChange1}>about</Link></li>
                    <li class="navbar-menu-li"><a href="#" class="navbar-menu-links"onClick={handleChange1}><i class="fa fa-facebook"></i></a></li>
                    <li class="navbar-menu-li"><a href="#" class="navbar-menu-links"onClick={handleChange1}><i class="fa fa-pinterest-p"></i></a></li>
                    <li class="navbar-menu-li"><a href="#" class="navbar-menu-links"onClick={handleChange1}><i class="fa fa-twitter"></i></a></li>
                    <li class="navbar-menu-li"><a href="#" class="navbar-menu-links"onClick={handleChange1}><i class="fa fa-instagram"></i></a></li>
                </ul>
            </nav>
        </div> 
    </header>
     {/* Main Section  */}
    <div class="navbar-banner">
        <img src="https://images.pexels.com/photos/1037992/pexels-photo-1037992.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500" alt=""/>
    </div>
    <div class="navbar-search">
        <div class="navbar-search-box">
            <input type="text" class="navbar-search-input" placeholder="search.."/>

            <button class="navbar-search-button">
                <i class="fas fa-search"></i>
            </button>
        </div>
    </div>
</body>
  )
}

export default Navbar